export const NUMBER_LENGTH = 4;
